import { type SVGProps } from 'react'

export function SignatureIcon (props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M12.25 9.91592L10.9923 8.82626C10.9508 8.78684 10.8985 8.76054 10.8421 8.75064C10.7857 8.74073 10.7276 8.74766 10.6751 8.77055C10.6226 8.79344 10.578 8.83129 10.5468 8.87938C10.5157 8.92746 10.4994 8.98364 10.5 9.04092V9.33259C10.5 9.4873 10.4385 9.63567 10.3291 9.74507C10.2197 9.85447 10.0714 9.91592 9.91667 9.91592H8.75C8.59529 9.91592 8.44692 9.85447 8.33752 9.74507C8.22812 9.63567 8.16667 9.4873 8.16667 9.33259C8.16667 7.84801 5.83858 7.01676 3.20833 6.99926C2.82156 6.99926 2.45063 7.1529 2.17714 7.42639C1.90365 7.69988 1.75 8.07082 1.75 8.45759C1.75 8.84436 1.90365 9.2153 2.17714 9.48879C2.45063 9.76228 2.82156 9.91592 3.20833 9.91592C5.63092 9.91592 5.97625 3.32717 6.538 2.04092C6.63289 1.8238 6.77927 1.63308 6.96445 1.48525C7.14963 1.33742 7.36804 1.23694 7.60079 1.1925C7.83354 1.14806 8.07361 1.16101 8.30023 1.23022C8.52685 1.29943 8.73319 1.42282 8.9014 1.5897C9.06961 1.75659 9.19462 1.96195 9.26562 2.18802C9.33661 2.41409 9.35145 2.65405 9.30885 2.88714C9.26625 3.12023 9.1675 3.33943 9.02113 3.52577C8.87476 3.71211 8.6852 3.85999 8.46883 3.95659'
        stroke='currentColor'
        strokeWidth='1.16667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.75 12.25H12.25'
        stroke='currentColor'
        strokeWidth='1.16667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
